// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"6590cb58","377":"f273d253","703":"4353f4b3"}[chunkId] + ".chunk.js";
};